import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AdminLogin from "@/pages/AdminLogin";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import CustomerDashboard from "@/pages/CustomerDashboard";
import NewIdea from "@/pages/NewIdea";
import ProjectDetail from "@/pages/ProjectDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProjectDetail from "@/pages/AdminProjectDetail";
import AdminContent from "@/pages/AdminContent";
import PaymentReturn from "@/pages/PaymentReturn";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import DistanceSales from "@/pages/DistanceSales";
import DeliveryReturn from "@/pages/DeliveryReturn";
import { Footer } from "@/components/Footer";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-gold">
        <div className="animate-pulse font-serif text-2xl">Yükleniyor…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role)
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return children;
}

function AppShell() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen film-grain">
      <Navbar />
      <Routes>
        <Route path="/" element={user ? <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace /> : <Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify" element={<VerifyEmail />} />
        <Route path="/payment" element={<PaymentReturn />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/gizlilik" element={<Privacy />} />
        <Route path="/mesafeli-satis" element={<DistanceSales />} />
        <Route path="/teslimat-iade" element={<DeliveryReturn />} />
        <Route path="/dashboard" element={<Protected role="customer"><CustomerDashboard /></Protected>} />
        <Route path="/new" element={<Protected role="customer"><NewIdea /></Protected>} />
        <Route path="/project/:id" element={<Protected role="customer"><ProjectDetail /></Protected>} />
        <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
        <Route path="/admin/content" element={<Protected role="admin"><AdminContent /></Protected>} />
        <Route path="/admin/project/:id" element={<Protected role="admin"><AdminProjectDetail /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <AppShell />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
